/**
 * Testing updating the product details page to increase add to bag. * https:www.notion.so/faire/Improved-benefits-for-new-users-Payment-terms-upsell-revamp-50346241994b4715b6375eee76c1a25b
 */
export const OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_SHIPPING_240820 = 'OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_SHIPPING_240820';
